// extracted by mini-css-extract-plugin
export var active = "_m0-2";
export var recordingDot = "_m0-1";
export var recordingIndicator = "_m0-0";